import React, { Component } from 'react'
import PermissionModal from './PermissionModal'
import VideoThumb from './VideoThumb'
import VideoModal from './VideoModal'
import Spinner from './Spinner'
import axios from 'axios'
import InfiniteScroll from 'react-infinite-scroller'
import * as routes from './routes'
import { withRouter } from 'react-router'
import { connect } from 'react-redux'
import requireLogin from './requireLogin'

import Radio from '@material-ui/core/Radio'
import RadioGroup from '@material-ui/core/RadioGroup'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import FormControl from '@material-ui/core/FormControl'
import FormLabel from '@material-ui/core/FormLabel'
import InputLabel from '@material-ui/core/InputLabel'
import MenuItem from '@material-ui/core/MenuItem'
import Select from '@material-ui/core/Select'
import ExpansionPanel from '@material-ui/core/ExpansionPanel'
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import _ from 'underscore'


import './Home.scss'

let empty_video = {
	short_code: '',
	vid_url: '',
	download_url: '',
	preview_url: '',
	thumb_url: '',
	premium: false,
	liked: false,
	likes: 0,
	views: 0,
	comments: []
}

class Home extends Component {
	fast_state = { page: 0, more: true, outstanding_requests: 0 }
	state = {
		videos: [],
		modal_active: false,
		active_video: empty_video,
		more: true,
		attempted_load: false,
		filter: '',
		order: '',
		category: '',
		search_text: '',
	}

	componentDidMount() {
		this.getVideo()
	}

	componentDidUpdate(prevProps) {
		if (prevProps.match.params.short_code != this.props.match.params.short_code) {
			this.getVideo()
		}
	}

	getVideo = () => {
		let { short_code } = this.props.match.params
		short_code && axios.get(`/api/get_video/${short_code}`)
			.then(r => {
				this.setState({ active_video: r.data, modal_active: true })
			})
	}

	getNextVideos = () => {
		if (!this.fast_state.more) {
			return
		}
		if (this.fast_state.outstanding_requests > 0) {
			setTimeout(this.getNextVideos, 100) // ghetto spin-waiting
			return
		}
		this.fast_state.outstanding_requests++
		let { page } = this.fast_state
		let { videos_url } = this.props
		let { filter, order, category, search_text } = this.state
		search_text = search_text.trim() ? `search_text=${search_text.trim()}` : ''
		category = `category=${category}`
		order = `order_by=${order}`
		filter = `filter_on=${filter}`
		videos_url = videos_url || '/api/get_videos'
		axios.get(`${videos_url}/${page}?${filter}&${order}&${category}&${search_text}`)
			.then(r => {
				let videos = r.data
				if (videos.length == 0) {
					this.fast_state.more = false
					this.setState({ more: false })
				} else {
					this.fast_state.page++
					videos = [...this.state.videos, ...videos]
					this.setState({ videos })
				}
			})
			.finally(() => {
				this.fast_state.outstanding_requests--
				this.setState({ attempted_load: true })
			})
	}

	toggleModal = (video) => {
		let { modal_active } = this.state
		modal_active && this.props.history.push(this.props.location.pathname.split('v/')[0])
		// modal_active && this.props.history.goBack()
		this.setState({ modal_active: !modal_active, active_video: empty_video })
	}


	toggleLike = short_code => {
		let { active_video } = this.state
		let new_video = { ...active_video }
		new_video.liked = !new_video.liked
		new_video.likes = new_video.likes + (new_video.liked ? 1 : -1)
		this.setState({ active_video: new_video })
		axios.post(`/api/toggle_like/${short_code}`)
			.then(r => {
				// this.setState({active_video: r.data})
			})
	}

	submitComment = comment => {
		let { active_video } = this.state
		let { short_code } = active_video
		axios.post(`/api/submit_comment/${short_code}`, { comment })
			.then(r => {
				let new_video = { ...active_video }
				new_video.comments = [...new_video.comments, r.data]
				this.setState({ active_video: new_video })
			})
	}

	setFilter = filter => {
		this.setState({ filter })
		this.clearVideos()
	}

	setOrder = order => {
		this.setState({ order })
		this.clearVideos()
	}

	setCategory = category => {
		this.setState({ category })
		this.clearVideos()
	}

	clearVideos = () => {
		this.fast_state = { page: 0, more: true, outstanding_requests: 0 }
		this.setState({ videos: [], more: true, attempted_load: false })
	}

	throttledClearVideos = _.throttle(this.clearVideos, 400)

	setSearchText = search_text => {
		this.setState({ search_text })
		this.throttledClearVideos()
	}

	render = () => {
		let videos = this.state.videos.map((v, i) => <VideoThumb video={v} toggleModal={this.toggleModal} key={i} />)
		let { modal_active, active_video, attempted_load, order, category, search_text } = this.state
		active_video.toggleLike = this.toggleLike
		active_video.submitComment = this.submitComment
		let { not_found_msg } = this.props
		not_found_msg = not_found_msg || 'No videos found.'
		return <>
			<ExpansionPanel className="sortbox">
				<ExpansionPanelSummary
					expandIcon={<ExpandMoreIcon />}
				>
					Options
				</ExpansionPanelSummary>
				<div className="sort_options">
					<div className="dropdowns">
						<FormControl variant="outlined" className={'sort_order'}>
							<InputLabel>Sort Order</InputLabel>
							<Select
								value={order}
								onChange={e => this.setOrder(e.target.value)}
								labelWidth={78}
							>
								<MenuItem value={'-created'}>Newest</MenuItem>
								<MenuItem value={'-views'}>Views</MenuItem>
								<MenuItem value={'-likes'}>Likes</MenuItem>
								<MenuItem value={'-downloads'}>Downloads</MenuItem>
								<MenuItem value={'+created'}>Oldest</MenuItem>
							</Select>
						</FormControl>
						<FormControl variant="outlined" className={'sort_order'}>
							<InputLabel>Category</InputLabel>
							<Select
								value={category}
								onChange={e => this.setCategory(e.target.value)}
								labelWidth={68}
							>
								<MenuItem value={''}>None</MenuItem>
								<MenuItem value={'Yoga Pants'}>Yoga Pants</MenuItem>
								<MenuItem value={'Tight Jeans'}>Tight Jeans</MenuItem>
								<MenuItem value={'Beach/Bikini'}>Beach/Bikini</MenuItem>
								<MenuItem value={'Short Shorts'}>Short Shorts</MenuItem>
								<MenuItem value={'Cleavage'}>Cleavage</MenuItem>
								<MenuItem value={'Feet'}>Feet</MenuItem>
								<MenuItem value={'Tight Dress'}>Tight Dress</MenuItem>
							</Select>
						</FormControl>
					</div>
					<FormControl>
						<FormLabel>Filter</FormLabel>
						<RadioGroup defaultValue="" name="customized-radios" onChange={e => this.setFilter(e.target.value)}>
							<FormControlLabel value="" control={<Radio />} label="All Videos" />
							<FormControlLabel value="free" control={<Radio />} label="Free Videos" />
							<FormControlLabel value="premium" control={<Radio />} label="Premium Videos" />
						</RadioGroup>
					</FormControl>
				</div>
			</ExpansionPanel>
			<div className="search_box">
				<input type="text" placeholder="Search..." value={search_text} onChange={e => this.setSearchText(e.target.value)} />
				<div className="search" onClick={() => search_text && this.setSearchText('')}></div>
			</div>

			<InfiniteScroll
				loadMore={this.getNextVideos}
				loader={<Spinner />}
				hasMore={this.state.more}
				className='videos_container'
				threshold={2000}
			>
				{videos.length > 0
					? videos
					: attempted_load && <div className='nothing_here'>{not_found_msg}</div>
				}
			</InfiniteScroll>
			<VideoModal v={active_video} modal_active={modal_active} toggleModal={this.toggleModal} />
		</>
	}
}

const mapStateToProps = state => ({
    access_token: state.access_token
})
export default withRouter(requireLogin(connect(mapStateToProps)(Home)))
// export default withRouter(Home)